import { render, staticRenderFns } from "./PartnerOperationApproval.vue?vue&type=template&id=2ca89ba1"
import script from "./PartnerOperationApproval.vue?vue&type=script&lang=ts"
export * from "./PartnerOperationApproval.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports